// extracted by mini-css-extract-plugin
export default {"loader":"loader--460d5e1a"};